import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { FileType } from "ui/Scripts/source/models/enums";
import { ListLine } from "../framework/listLine";
import { IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";

//AttachmentListMenu
export interface IAttachmentSummaryListMenuProp {
    item: IFileAttachment;
    onDownload: () => void;
    onCancel: () => void;
}

export class AttachmentSummaryListMenu extends React.Component<IAttachmentSummaryListMenuProp, {}> {
    handleDownloadClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onDownload();
    };

    handleCancelClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onCancel();
    };
        
    render() {
        const item = this.props.item;
        if (Base.isNullOrUndefined(item)) return null;
        const canDownload = !item.isNew();
        return (
            <div className="listPopupMenu" onClick={this.handleCancelClick}>
                <div className="menu">
                    <div className={"line" + (canDownload ? "" : " disabled")} onClick={canDownload ? this.handleDownloadClick : null}>{Translations.Download}</div>
                    <div className="line" onClick={this.handleCancelClick}>{Translations.Cancel}</div>
                </div>
            </div>
        );
    }
}

export interface IAttachmentSummaryImageProp {
    lateThreshold: number;
    selectedId: string;
    attachment: IFileAttachment;
    onClick: (id: string) => void;
    onLongPress: (id: string) => void;
}

export class AttachmentSummaryImage extends React.Component<IAttachmentSummaryImageProp, {}> {
    handleDownloadClick = () => {
        this.props.onClick(this.props.attachment.id);
    };

    render() {
        const timeToleranceInJsTicks = 500;
        const lateThreshold = this.props.lateThreshold;
        const attachment = this.props.attachment;
        const isLate = !Base.isNullOrUndefined(lateThreshold) && attachment.modifyDate > (lateThreshold + timeToleranceInJsTicks);
        return (
            <ListLine
                id={attachment.id}
                first={false}
                selected={this.props.selectedId === attachment.id}
                classes={"attachmentImage" + (isLate ? " late" : "")}
                onClick={this.props.onClick}
                onLongPress={this.props.onLongPress}
                onRefreshList={null}>
                <img src={attachment.thumbnail} alt={attachment.name} />
            </ListLine>
        );
    }
}

export interface IAttachmentSummaryListLineProp {
    lateThreshold: number;
    selectedId: string;
    attachment: IFileAttachment;
    onClick: (id: string) => void;
    onLongPress: (id: string) => void;
}

export class AttachmentSummaryListLine extends React.Component<IAttachmentSummaryListLineProp, {}> {
    handleDownloadClick = () => {
        this.props.onClick(this.props.attachment.id);
    };

    render() {
        const timeToleranceInJsTicks = 500;
        const lateThreshold = this.props.lateThreshold;
        const attachment = this.props.attachment;
        const isLate = !Base.isNullOrUndefined(lateThreshold) && attachment.modifyDate > (lateThreshold + timeToleranceInJsTicks);
        return (
            <ListLine
                id={attachment.id}
                first={false}
                selected={this.props.selectedId === attachment.id}
                classes={"attachment" + (isLate ? " late" : "")}
                onClick={this.props.onClick}
                onLongPress={this.props.onLongPress}
                onRefreshList={null}>
                <span className={"icon file file_type_" + attachment.type}></span>
                <span className="name">{attachment.name}</span>
                <span>(</span>
                <span className="size">{Base.intToFileSizeStr(attachment.size, false)}</span>
                {isLate &&
                        <span>, </span>
                }
                {isLate &&
                        <span className="modifyDate">{Base.timeToDateStr(attachment.modifyDate)}</span>
                }
                <span>)</span>
            </ListLine>
        );
    }
}

export interface IAttachmentSummaryListProp {
    lateThreshold: number;
    attachments: IFileAttachment[];
    onDownloadAttachment: (id: string) => void;
}

interface IAttachmentSummaryListState {
    selectedId: string;
    showListMenu: boolean;
}

export class AttachmentSummaryList extends React.Component<IAttachmentSummaryListProp, IAttachmentSummaryListState> {
    constructor(props) {
        super(props);
        this.state = { selectedId: null, showListMenu: false };
    }

    handleMenuDownload = () => {
        const selectedId = this.state.selectedId;
        if (Base.isNullOrEmpty(selectedId)) return;
        this.props.onDownloadAttachment(selectedId);
        this.setState({
            showListMenu: false
        });
    };

    handleAttachmentClick = (id: string) => {
        this.setState({
            selectedId: id
        });
    };

    handleAttachmentLongPress = (id: string) => {
        this.setState({
            selectedId: id,
            showListMenu: true
        });
    };

    handleMenuCancel = () => {
        this.setState({
            showListMenu: false
        });
    };

    render() {
        const lateThreshold = this.props.lateThreshold;
        const attachments = this.props.attachments;
        const imageAttachments = attachments.filter(i => i.type === FileType.Image);
        const fileAttachments = attachments.filter(i => i.type !== FileType.Image);
        const selectedId = this.state.selectedId;
        const selectedAttachment = attachments.find(i => i.id === selectedId);
        return (
            <div className="attachmentsContainer">
                <div className="attachmentImages">
                    {imageAttachments.map((attachment) =>
                        <AttachmentSummaryImage
                            key={attachment.id}
                            lateThreshold={lateThreshold}
                            selectedId={this.state.selectedId}
                            attachment={attachment}
                            onClick={this.handleAttachmentClick}
                            onLongPress={!attachment.isNew() ? this.handleAttachmentLongPress : null}
                        />
                    )}
                </div>
                <div className="attachments">
                    {fileAttachments.map((attachment) =>
                        <AttachmentSummaryListLine
                            key={attachment.id}
                            lateThreshold={lateThreshold}
                            selectedId={this.state.selectedId}
                            attachment={attachment}
                            onClick={this.handleAttachmentClick}
                            onLongPress={!attachment.isNew() ? this.handleAttachmentLongPress : null}
                        />
                    )}
                </div>
                {this.state.showListMenu &&
                    <AttachmentSummaryListMenu
                        item={selectedAttachment}
                        onDownload={this.handleMenuDownload}
                        onCancel={this.handleMenuCancel}
                    />
                }
            </div>
        );
    }
}